import { BaseComponent } from "../../../components/BaseComponent";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import styled from "styled-components";
import { Modal, ModalControls } from "../../../components/Modal";
import { Button } from "../../../components/Buttons";
import { updateWorkflow } from "../actions";
import { selectWorkflow } from "../selectors";

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

export class WorkflowTaskActionsContainerComp extends BaseComponent {

  onClickDeleteBtn() {
    this.setState({ removeTaskConfirmation: true, removeTaskId: this.props.task.id });
  }

  renderConfirmationModal() {
    if (!this.state.removeTaskConfirmation) return '';

    return (
      <Modal onClose={this.setStateFn({ removeTaskConfirmation: false })} title={this.lbl(`workflows.details.tasks.removeConfirmationTitle`)}>
        <ModalControls>
          <Button
            onClick={() => {
              this.removeTask();
              this.setState({ removeTaskConfirmation: false, removeTaskId: null });
            }}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ removeTaskConfirmation: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  removeTask() {
    this.props.removeTask(this.state.removeTaskId);
  }

  render() {
    return (
      <>
        <ActionsContainer>
          <IconWrapper color={'green'}>
            <div
              onClick={evt => {
                evt.stopPropagation();
              }}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faFileSignature} />
            </div>
          </IconWrapper>
          {this.props.removeTask && <IconWrapper color={'red'}>
            <div
              onClick={evt => {
                evt.stopPropagation();
                this.onClickDeleteBtn(evt);
              }}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </IconWrapper>}
        </ActionsContainer>
        {this.renderConfirmationModal()}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflow: selectWorkflow(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(workflowId, dto) {
      dispatch(updateWorkflow(workflowId, dto));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowTaskActionsContainer = compose(withConnect, withRouter)(WorkflowTaskActionsContainerComp);
